import React from 'react';
import './MainContainer.css';

const Loader = (props)=>{
  return (
    <div data-testid="loader" className={"spinner"} style={{height: props?.height}}>
      <div className={"spinner__circle"}>
        <div className={"spinner__circle_dot"}></div>

        <div className={"spinner__circle_inner"}></div>
      </div>
    </div>
  )
};

export default Loader;